import 'react-toastify/dist/ReactToastify.css';
import '../toast.css';

import React from 'react';
import { ToastContainer } from 'react-toastify';

import {
  Grid,
  Row,
} from 'react-bootstrap';

import Navigation from '../components/Navigation';
import Onboarding from '../components/Onboarding';
import EnvironmentBanner from '../components/EnvironmentBanner';
import MetamaskWrapper from '../components/MetamaskWrapper';
import LayoutWrapperUI from '../components/ui/LayoutWrapperUI';
import FooterUI from '../components/ui/FooterUI';

const DefaultLayout = ({ children }) => (
  <LayoutWrapperUI>

    <Navigation />

    <Onboarding />

    <Grid>

      <Row>
        <MetamaskWrapper>
          {children}
        </MetamaskWrapper>
      </Row>

    </Grid>

    <ToastContainer />

    <FooterUI />

  </LayoutWrapperUI>
);


export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout.js